// source: apigateway/category/seo.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.category.GetSeoReply', null, global);
goog.exportSymbol('proto.category.GetSeoRequest', null, global);
goog.exportSymbol('proto.category.Rating', null, global);
goog.exportSymbol('proto.category.RecentOrderService', null, global);
goog.exportSymbol('proto.category.Tag', null, global);
goog.exportSymbol('proto.category.TrendKeyword', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.category.GetSeoRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.category.GetSeoRequest.repeatedFields_, null);
};
goog.inherits(proto.category.GetSeoRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.category.GetSeoRequest.displayName = 'proto.category.GetSeoRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.category.GetSeoReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.category.GetSeoReply.repeatedFields_, null);
};
goog.inherits(proto.category.GetSeoReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.category.GetSeoReply.displayName = 'proto.category.GetSeoReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.category.TrendKeyword = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.category.TrendKeyword, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.category.TrendKeyword.displayName = 'proto.category.TrendKeyword';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.category.RecentOrderService = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.category.RecentOrderService, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.category.RecentOrderService.displayName = 'proto.category.RecentOrderService';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.category.Tag = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.category.Tag, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.category.Tag.displayName = 'proto.category.Tag';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.category.Rating = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.category.Rating, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.category.Rating.displayName = 'proto.category.Rating';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.category.GetSeoRequest.repeatedFields_ = [5,6,7,8,9,10,11,12,16,17,18,19];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.category.GetSeoRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.category.GetSeoRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.category.GetSeoRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.category.GetSeoRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    keyword: jspb.Message.getFieldWithDefault(msg, 2, ""),
    categoryClass: jspb.Message.getFieldWithDefault(msg, 3, ""),
    page: jspb.Message.getFieldWithDefault(msg, 4, 0),
    styleIdsList: (f = jspb.Message.getRepeatedField(msg, 5)) == null ? undefined : f,
    contentIdsList: (f = jspb.Message.getRepeatedField(msg, 6)) == null ? undefined : f,
    genreIdsList: (f = jspb.Message.getRepeatedField(msg, 7)) == null ? undefined : f,
    usageIdsList: (f = jspb.Message.getRepeatedField(msg, 8)) == null ? undefined : f,
    occupationIdsList: (f = jspb.Message.getRepeatedField(msg, 9)) == null ? undefined : f,
    industryIdsList: (f = jspb.Message.getRepeatedField(msg, 10)) == null ? undefined : f,
    languageIdsList: (f = jspb.Message.getRepeatedField(msg, 11)) == null ? undefined : f,
    fileTypeIdsList: (f = jspb.Message.getRepeatedField(msg, 12)) == null ? undefined : f,
    serviceClass: jspb.Message.getFieldWithDefault(msg, 13, 0),
    masterCategoryId: jspb.Message.getFieldWithDefault(msg, 14, 0),
    masterCategoryTypeId: jspb.Message.getFieldWithDefault(msg, 15, 0),
    techniqueIdsList: (f = jspb.Message.getRepeatedField(msg, 16)) == null ? undefined : f,
    paperSizeIdsList: (f = jspb.Message.getRepeatedField(msg, 17)) == null ? undefined : f,
    baseScopeIdsList: (f = jspb.Message.getRepeatedField(msg, 18)) == null ? undefined : f,
    sexIdsList: (f = jspb.Message.getRepeatedField(msg, 19)) == null ? undefined : f,
    serviceKind: jspb.Message.getFieldWithDefault(msg, 21, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.category.GetSeoRequest}
 */
proto.category.GetSeoRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.category.GetSeoRequest;
  return proto.category.GetSeoRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.category.GetSeoRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.category.GetSeoRequest}
 */
proto.category.GetSeoRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setKeyword(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCategoryClass(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPage(value);
      break;
    case 5:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt32());
      msg.setStyleIdsList(value);
      break;
    case 6:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt32());
      msg.setContentIdsList(value);
      break;
    case 7:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt32());
      msg.setGenreIdsList(value);
      break;
    case 8:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt32());
      msg.setUsageIdsList(value);
      break;
    case 9:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt32());
      msg.setOccupationIdsList(value);
      break;
    case 10:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt32());
      msg.setIndustryIdsList(value);
      break;
    case 11:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt32());
      msg.setLanguageIdsList(value);
      break;
    case 12:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt32());
      msg.setFileTypeIdsList(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setServiceClass(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMasterCategoryId(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMasterCategoryTypeId(value);
      break;
    case 16:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt32());
      msg.setTechniqueIdsList(value);
      break;
    case 17:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt32());
      msg.setPaperSizeIdsList(value);
      break;
    case 18:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt32());
      msg.setBaseScopeIdsList(value);
      break;
    case 19:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt32());
      msg.setSexIdsList(value);
      break;
    case 21:
      var value = /** @type {string} */ (reader.readString());
      msg.setServiceKind(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.category.GetSeoRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.category.GetSeoRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.category.GetSeoRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.category.GetSeoRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getKeyword();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCategoryClass();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPage();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getStyleIdsList();
  if (f.length > 0) {
    writer.writePackedInt32(
      5,
      f
    );
  }
  f = message.getContentIdsList();
  if (f.length > 0) {
    writer.writePackedInt32(
      6,
      f
    );
  }
  f = message.getGenreIdsList();
  if (f.length > 0) {
    writer.writePackedInt32(
      7,
      f
    );
  }
  f = message.getUsageIdsList();
  if (f.length > 0) {
    writer.writePackedInt32(
      8,
      f
    );
  }
  f = message.getOccupationIdsList();
  if (f.length > 0) {
    writer.writePackedInt32(
      9,
      f
    );
  }
  f = message.getIndustryIdsList();
  if (f.length > 0) {
    writer.writePackedInt32(
      10,
      f
    );
  }
  f = message.getLanguageIdsList();
  if (f.length > 0) {
    writer.writePackedInt32(
      11,
      f
    );
  }
  f = message.getFileTypeIdsList();
  if (f.length > 0) {
    writer.writePackedInt32(
      12,
      f
    );
  }
  f = message.getServiceClass();
  if (f !== 0) {
    writer.writeInt32(
      13,
      f
    );
  }
  f = message.getMasterCategoryId();
  if (f !== 0) {
    writer.writeInt32(
      14,
      f
    );
  }
  f = message.getMasterCategoryTypeId();
  if (f !== 0) {
    writer.writeInt32(
      15,
      f
    );
  }
  f = message.getTechniqueIdsList();
  if (f.length > 0) {
    writer.writePackedInt32(
      16,
      f
    );
  }
  f = message.getPaperSizeIdsList();
  if (f.length > 0) {
    writer.writePackedInt32(
      17,
      f
    );
  }
  f = message.getBaseScopeIdsList();
  if (f.length > 0) {
    writer.writePackedInt32(
      18,
      f
    );
  }
  f = message.getSexIdsList();
  if (f.length > 0) {
    writer.writePackedInt32(
      19,
      f
    );
  }
  f = message.getServiceKind();
  if (f.length > 0) {
    writer.writeString(
      21,
      f
    );
  }
};


/**
 * optional string keyword = 2;
 * @return {string}
 */
proto.category.GetSeoRequest.prototype.getKeyword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.category.GetSeoRequest} returns this
 */
proto.category.GetSeoRequest.prototype.setKeyword = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string category_class = 3;
 * @return {string}
 */
proto.category.GetSeoRequest.prototype.getCategoryClass = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.category.GetSeoRequest} returns this
 */
proto.category.GetSeoRequest.prototype.setCategoryClass = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 page = 4;
 * @return {number}
 */
proto.category.GetSeoRequest.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.category.GetSeoRequest} returns this
 */
proto.category.GetSeoRequest.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * repeated int32 style_ids = 5;
 * @return {!Array<number>}
 */
proto.category.GetSeoRequest.prototype.getStyleIdsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 5));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.category.GetSeoRequest} returns this
 */
proto.category.GetSeoRequest.prototype.setStyleIdsList = function(value) {
  return jspb.Message.setField(this, 5, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.category.GetSeoRequest} returns this
 */
proto.category.GetSeoRequest.prototype.addStyleIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 5, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.category.GetSeoRequest} returns this
 */
proto.category.GetSeoRequest.prototype.clearStyleIdsList = function() {
  return this.setStyleIdsList([]);
};


/**
 * repeated int32 content_ids = 6;
 * @return {!Array<number>}
 */
proto.category.GetSeoRequest.prototype.getContentIdsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 6));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.category.GetSeoRequest} returns this
 */
proto.category.GetSeoRequest.prototype.setContentIdsList = function(value) {
  return jspb.Message.setField(this, 6, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.category.GetSeoRequest} returns this
 */
proto.category.GetSeoRequest.prototype.addContentIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 6, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.category.GetSeoRequest} returns this
 */
proto.category.GetSeoRequest.prototype.clearContentIdsList = function() {
  return this.setContentIdsList([]);
};


/**
 * repeated int32 genre_ids = 7;
 * @return {!Array<number>}
 */
proto.category.GetSeoRequest.prototype.getGenreIdsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 7));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.category.GetSeoRequest} returns this
 */
proto.category.GetSeoRequest.prototype.setGenreIdsList = function(value) {
  return jspb.Message.setField(this, 7, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.category.GetSeoRequest} returns this
 */
proto.category.GetSeoRequest.prototype.addGenreIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 7, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.category.GetSeoRequest} returns this
 */
proto.category.GetSeoRequest.prototype.clearGenreIdsList = function() {
  return this.setGenreIdsList([]);
};


/**
 * repeated int32 usage_ids = 8;
 * @return {!Array<number>}
 */
proto.category.GetSeoRequest.prototype.getUsageIdsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 8));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.category.GetSeoRequest} returns this
 */
proto.category.GetSeoRequest.prototype.setUsageIdsList = function(value) {
  return jspb.Message.setField(this, 8, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.category.GetSeoRequest} returns this
 */
proto.category.GetSeoRequest.prototype.addUsageIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 8, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.category.GetSeoRequest} returns this
 */
proto.category.GetSeoRequest.prototype.clearUsageIdsList = function() {
  return this.setUsageIdsList([]);
};


/**
 * repeated int32 occupation_ids = 9;
 * @return {!Array<number>}
 */
proto.category.GetSeoRequest.prototype.getOccupationIdsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 9));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.category.GetSeoRequest} returns this
 */
proto.category.GetSeoRequest.prototype.setOccupationIdsList = function(value) {
  return jspb.Message.setField(this, 9, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.category.GetSeoRequest} returns this
 */
proto.category.GetSeoRequest.prototype.addOccupationIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 9, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.category.GetSeoRequest} returns this
 */
proto.category.GetSeoRequest.prototype.clearOccupationIdsList = function() {
  return this.setOccupationIdsList([]);
};


/**
 * repeated int32 industry_ids = 10;
 * @return {!Array<number>}
 */
proto.category.GetSeoRequest.prototype.getIndustryIdsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 10));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.category.GetSeoRequest} returns this
 */
proto.category.GetSeoRequest.prototype.setIndustryIdsList = function(value) {
  return jspb.Message.setField(this, 10, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.category.GetSeoRequest} returns this
 */
proto.category.GetSeoRequest.prototype.addIndustryIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 10, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.category.GetSeoRequest} returns this
 */
proto.category.GetSeoRequest.prototype.clearIndustryIdsList = function() {
  return this.setIndustryIdsList([]);
};


/**
 * repeated int32 language_ids = 11;
 * @return {!Array<number>}
 */
proto.category.GetSeoRequest.prototype.getLanguageIdsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 11));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.category.GetSeoRequest} returns this
 */
proto.category.GetSeoRequest.prototype.setLanguageIdsList = function(value) {
  return jspb.Message.setField(this, 11, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.category.GetSeoRequest} returns this
 */
proto.category.GetSeoRequest.prototype.addLanguageIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 11, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.category.GetSeoRequest} returns this
 */
proto.category.GetSeoRequest.prototype.clearLanguageIdsList = function() {
  return this.setLanguageIdsList([]);
};


/**
 * repeated int32 file_type_ids = 12;
 * @return {!Array<number>}
 */
proto.category.GetSeoRequest.prototype.getFileTypeIdsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 12));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.category.GetSeoRequest} returns this
 */
proto.category.GetSeoRequest.prototype.setFileTypeIdsList = function(value) {
  return jspb.Message.setField(this, 12, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.category.GetSeoRequest} returns this
 */
proto.category.GetSeoRequest.prototype.addFileTypeIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 12, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.category.GetSeoRequest} returns this
 */
proto.category.GetSeoRequest.prototype.clearFileTypeIdsList = function() {
  return this.setFileTypeIdsList([]);
};


/**
 * optional int32 service_class = 13;
 * @return {number}
 */
proto.category.GetSeoRequest.prototype.getServiceClass = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.category.GetSeoRequest} returns this
 */
proto.category.GetSeoRequest.prototype.setServiceClass = function(value) {
  return jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional int32 master_category_id = 14;
 * @return {number}
 */
proto.category.GetSeoRequest.prototype.getMasterCategoryId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {number} value
 * @return {!proto.category.GetSeoRequest} returns this
 */
proto.category.GetSeoRequest.prototype.setMasterCategoryId = function(value) {
  return jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * optional int32 master_category_type_id = 15;
 * @return {number}
 */
proto.category.GetSeoRequest.prototype.getMasterCategoryTypeId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {number} value
 * @return {!proto.category.GetSeoRequest} returns this
 */
proto.category.GetSeoRequest.prototype.setMasterCategoryTypeId = function(value) {
  return jspb.Message.setProto3IntField(this, 15, value);
};


/**
 * repeated int32 technique_ids = 16;
 * @return {!Array<number>}
 */
proto.category.GetSeoRequest.prototype.getTechniqueIdsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 16));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.category.GetSeoRequest} returns this
 */
proto.category.GetSeoRequest.prototype.setTechniqueIdsList = function(value) {
  return jspb.Message.setField(this, 16, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.category.GetSeoRequest} returns this
 */
proto.category.GetSeoRequest.prototype.addTechniqueIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 16, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.category.GetSeoRequest} returns this
 */
proto.category.GetSeoRequest.prototype.clearTechniqueIdsList = function() {
  return this.setTechniqueIdsList([]);
};


/**
 * repeated int32 paper_size_ids = 17;
 * @return {!Array<number>}
 */
proto.category.GetSeoRequest.prototype.getPaperSizeIdsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 17));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.category.GetSeoRequest} returns this
 */
proto.category.GetSeoRequest.prototype.setPaperSizeIdsList = function(value) {
  return jspb.Message.setField(this, 17, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.category.GetSeoRequest} returns this
 */
proto.category.GetSeoRequest.prototype.addPaperSizeIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 17, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.category.GetSeoRequest} returns this
 */
proto.category.GetSeoRequest.prototype.clearPaperSizeIdsList = function() {
  return this.setPaperSizeIdsList([]);
};


/**
 * repeated int32 base_scope_ids = 18;
 * @return {!Array<number>}
 */
proto.category.GetSeoRequest.prototype.getBaseScopeIdsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 18));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.category.GetSeoRequest} returns this
 */
proto.category.GetSeoRequest.prototype.setBaseScopeIdsList = function(value) {
  return jspb.Message.setField(this, 18, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.category.GetSeoRequest} returns this
 */
proto.category.GetSeoRequest.prototype.addBaseScopeIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 18, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.category.GetSeoRequest} returns this
 */
proto.category.GetSeoRequest.prototype.clearBaseScopeIdsList = function() {
  return this.setBaseScopeIdsList([]);
};


/**
 * repeated int32 sex_ids = 19;
 * @return {!Array<number>}
 */
proto.category.GetSeoRequest.prototype.getSexIdsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 19));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.category.GetSeoRequest} returns this
 */
proto.category.GetSeoRequest.prototype.setSexIdsList = function(value) {
  return jspb.Message.setField(this, 19, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.category.GetSeoRequest} returns this
 */
proto.category.GetSeoRequest.prototype.addSexIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 19, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.category.GetSeoRequest} returns this
 */
proto.category.GetSeoRequest.prototype.clearSexIdsList = function() {
  return this.setSexIdsList([]);
};


/**
 * optional string service_kind = 21;
 * @return {string}
 */
proto.category.GetSeoRequest.prototype.getServiceKind = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ""));
};


/**
 * @param {string} value
 * @return {!proto.category.GetSeoRequest} returns this
 */
proto.category.GetSeoRequest.prototype.setServiceKind = function(value) {
  return jspb.Message.setProto3StringField(this, 21, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.category.GetSeoReply.repeatedFields_ = [7,10,14];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.category.GetSeoReply.prototype.toObject = function(opt_includeInstance) {
  return proto.category.GetSeoReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.category.GetSeoReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.category.GetSeoReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    title: jspb.Message.getFieldWithDefault(msg, 2, ""),
    description: jspb.Message.getFieldWithDefault(msg, 3, ""),
    metaDescription: jspb.Message.getFieldWithDefault(msg, 4, ""),
    keywords: jspb.Message.getFieldWithDefault(msg, 5, ""),
    footerText: jspb.Message.getFieldWithDefault(msg, 6, ""),
    trendKeywordsList: jspb.Message.toObjectList(msg.getTrendKeywordsList(),
    proto.category.TrendKeyword.toObject, includeInstance),
    canonical: jspb.Message.getFieldWithDefault(msg, 8, ""),
    metaTitle: jspb.Message.getFieldWithDefault(msg, 9, ""),
    recentOrderServiceList: jspb.Message.toObjectList(msg.getRecentOrderServiceList(),
    proto.category.RecentOrderService.toObject, includeInstance),
    parentKeyword: jspb.Message.getFieldWithDefault(msg, 11, ""),
    childKeyword: jspb.Message.getFieldWithDefault(msg, 12, ""),
    tag: (f = msg.getTag()) && proto.category.Tag.toObject(includeInstance, f),
    ratingsList: jspb.Message.toObjectList(msg.getRatingsList(),
    proto.category.Rating.toObject, includeInstance),
    isTrendKeywordPage: jspb.Message.getBooleanFieldWithDefault(msg, 15, false),
    masterCategoryName: jspb.Message.getFieldWithDefault(msg, 16, ""),
    masterCategoryTypeName: jspb.Message.getFieldWithDefault(msg, 17, ""),
    isTagPage: jspb.Message.getBooleanFieldWithDefault(msg, 18, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.category.GetSeoReply}
 */
proto.category.GetSeoReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.category.GetSeoReply;
  return proto.category.GetSeoReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.category.GetSeoReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.category.GetSeoReply}
 */
proto.category.GetSeoReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setMetaDescription(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setKeywords(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setFooterText(value);
      break;
    case 7:
      var value = new proto.category.TrendKeyword;
      reader.readMessage(value,proto.category.TrendKeyword.deserializeBinaryFromReader);
      msg.addTrendKeywords(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setCanonical(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setMetaTitle(value);
      break;
    case 10:
      var value = new proto.category.RecentOrderService;
      reader.readMessage(value,proto.category.RecentOrderService.deserializeBinaryFromReader);
      msg.addRecentOrderService(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setParentKeyword(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setChildKeyword(value);
      break;
    case 13:
      var value = new proto.category.Tag;
      reader.readMessage(value,proto.category.Tag.deserializeBinaryFromReader);
      msg.setTag(value);
      break;
    case 14:
      var value = new proto.category.Rating;
      reader.readMessage(value,proto.category.Rating.deserializeBinaryFromReader);
      msg.addRatings(value);
      break;
    case 15:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsTrendKeywordPage(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setMasterCategoryName(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setMasterCategoryTypeName(value);
      break;
    case 18:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsTagPage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.category.GetSeoReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.category.GetSeoReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.category.GetSeoReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.category.GetSeoReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getMetaDescription();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getKeywords();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getFooterText();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getTrendKeywordsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      proto.category.TrendKeyword.serializeBinaryToWriter
    );
  }
  f = message.getCanonical();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getMetaTitle();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getRecentOrderServiceList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      10,
      f,
      proto.category.RecentOrderService.serializeBinaryToWriter
    );
  }
  f = message.getParentKeyword();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getChildKeyword();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getTag();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      proto.category.Tag.serializeBinaryToWriter
    );
  }
  f = message.getRatingsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      14,
      f,
      proto.category.Rating.serializeBinaryToWriter
    );
  }
  f = message.getIsTrendKeywordPage();
  if (f) {
    writer.writeBool(
      15,
      f
    );
  }
  f = message.getMasterCategoryName();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getMasterCategoryTypeName();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getIsTagPage();
  if (f) {
    writer.writeBool(
      18,
      f
    );
  }
};


/**
 * optional string title = 2;
 * @return {string}
 */
proto.category.GetSeoReply.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.category.GetSeoReply} returns this
 */
proto.category.GetSeoReply.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string description = 3;
 * @return {string}
 */
proto.category.GetSeoReply.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.category.GetSeoReply} returns this
 */
proto.category.GetSeoReply.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string meta_description = 4;
 * @return {string}
 */
proto.category.GetSeoReply.prototype.getMetaDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.category.GetSeoReply} returns this
 */
proto.category.GetSeoReply.prototype.setMetaDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string keywords = 5;
 * @return {string}
 */
proto.category.GetSeoReply.prototype.getKeywords = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.category.GetSeoReply} returns this
 */
proto.category.GetSeoReply.prototype.setKeywords = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string footer_text = 6;
 * @return {string}
 */
proto.category.GetSeoReply.prototype.getFooterText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.category.GetSeoReply} returns this
 */
proto.category.GetSeoReply.prototype.setFooterText = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * repeated TrendKeyword trend_keywords = 7;
 * @return {!Array<!proto.category.TrendKeyword>}
 */
proto.category.GetSeoReply.prototype.getTrendKeywordsList = function() {
  return /** @type{!Array<!proto.category.TrendKeyword>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.category.TrendKeyword, 7));
};


/**
 * @param {!Array<!proto.category.TrendKeyword>} value
 * @return {!proto.category.GetSeoReply} returns this
*/
proto.category.GetSeoReply.prototype.setTrendKeywordsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.category.TrendKeyword=} opt_value
 * @param {number=} opt_index
 * @return {!proto.category.TrendKeyword}
 */
proto.category.GetSeoReply.prototype.addTrendKeywords = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.category.TrendKeyword, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.category.GetSeoReply} returns this
 */
proto.category.GetSeoReply.prototype.clearTrendKeywordsList = function() {
  return this.setTrendKeywordsList([]);
};


/**
 * optional string canonical = 8;
 * @return {string}
 */
proto.category.GetSeoReply.prototype.getCanonical = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.category.GetSeoReply} returns this
 */
proto.category.GetSeoReply.prototype.setCanonical = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string meta_title = 9;
 * @return {string}
 */
proto.category.GetSeoReply.prototype.getMetaTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.category.GetSeoReply} returns this
 */
proto.category.GetSeoReply.prototype.setMetaTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * repeated RecentOrderService recent_order_service = 10;
 * @return {!Array<!proto.category.RecentOrderService>}
 */
proto.category.GetSeoReply.prototype.getRecentOrderServiceList = function() {
  return /** @type{!Array<!proto.category.RecentOrderService>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.category.RecentOrderService, 10));
};


/**
 * @param {!Array<!proto.category.RecentOrderService>} value
 * @return {!proto.category.GetSeoReply} returns this
*/
proto.category.GetSeoReply.prototype.setRecentOrderServiceList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 10, value);
};


/**
 * @param {!proto.category.RecentOrderService=} opt_value
 * @param {number=} opt_index
 * @return {!proto.category.RecentOrderService}
 */
proto.category.GetSeoReply.prototype.addRecentOrderService = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 10, opt_value, proto.category.RecentOrderService, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.category.GetSeoReply} returns this
 */
proto.category.GetSeoReply.prototype.clearRecentOrderServiceList = function() {
  return this.setRecentOrderServiceList([]);
};


/**
 * optional string parent_keyword = 11;
 * @return {string}
 */
proto.category.GetSeoReply.prototype.getParentKeyword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.category.GetSeoReply} returns this
 */
proto.category.GetSeoReply.prototype.setParentKeyword = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string child_keyword = 12;
 * @return {string}
 */
proto.category.GetSeoReply.prototype.getChildKeyword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.category.GetSeoReply} returns this
 */
proto.category.GetSeoReply.prototype.setChildKeyword = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional Tag tag = 13;
 * @return {?proto.category.Tag}
 */
proto.category.GetSeoReply.prototype.getTag = function() {
  return /** @type{?proto.category.Tag} */ (
    jspb.Message.getWrapperField(this, proto.category.Tag, 13));
};


/**
 * @param {?proto.category.Tag|undefined} value
 * @return {!proto.category.GetSeoReply} returns this
*/
proto.category.GetSeoReply.prototype.setTag = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.category.GetSeoReply} returns this
 */
proto.category.GetSeoReply.prototype.clearTag = function() {
  return this.setTag(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.category.GetSeoReply.prototype.hasTag = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * repeated Rating ratings = 14;
 * @return {!Array<!proto.category.Rating>}
 */
proto.category.GetSeoReply.prototype.getRatingsList = function() {
  return /** @type{!Array<!proto.category.Rating>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.category.Rating, 14));
};


/**
 * @param {!Array<!proto.category.Rating>} value
 * @return {!proto.category.GetSeoReply} returns this
*/
proto.category.GetSeoReply.prototype.setRatingsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 14, value);
};


/**
 * @param {!proto.category.Rating=} opt_value
 * @param {number=} opt_index
 * @return {!proto.category.Rating}
 */
proto.category.GetSeoReply.prototype.addRatings = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 14, opt_value, proto.category.Rating, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.category.GetSeoReply} returns this
 */
proto.category.GetSeoReply.prototype.clearRatingsList = function() {
  return this.setRatingsList([]);
};


/**
 * optional bool is_trend_keyword_page = 15;
 * @return {boolean}
 */
proto.category.GetSeoReply.prototype.getIsTrendKeywordPage = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 15, false));
};


/**
 * @param {boolean} value
 * @return {!proto.category.GetSeoReply} returns this
 */
proto.category.GetSeoReply.prototype.setIsTrendKeywordPage = function(value) {
  return jspb.Message.setProto3BooleanField(this, 15, value);
};


/**
 * optional string master_category_name = 16;
 * @return {string}
 */
proto.category.GetSeoReply.prototype.getMasterCategoryName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.category.GetSeoReply} returns this
 */
proto.category.GetSeoReply.prototype.setMasterCategoryName = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional string master_category_type_name = 17;
 * @return {string}
 */
proto.category.GetSeoReply.prototype.getMasterCategoryTypeName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.category.GetSeoReply} returns this
 */
proto.category.GetSeoReply.prototype.setMasterCategoryTypeName = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional bool is_tag_page = 18;
 * @return {boolean}
 */
proto.category.GetSeoReply.prototype.getIsTagPage = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 18, false));
};


/**
 * @param {boolean} value
 * @return {!proto.category.GetSeoReply} returns this
 */
proto.category.GetSeoReply.prototype.setIsTagPage = function(value) {
  return jspb.Message.setProto3BooleanField(this, 18, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.category.TrendKeyword.prototype.toObject = function(opt_includeInstance) {
  return proto.category.TrendKeyword.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.category.TrendKeyword} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.category.TrendKeyword.toObject = function(includeInstance, msg) {
  var f, obj = {
    keywords: jspb.Message.getFieldWithDefault(msg, 1, ""),
    url: jspb.Message.getFieldWithDefault(msg, 2, ""),
    path: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.category.TrendKeyword}
 */
proto.category.TrendKeyword.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.category.TrendKeyword;
  return proto.category.TrendKeyword.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.category.TrendKeyword} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.category.TrendKeyword}
 */
proto.category.TrendKeyword.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setKeywords(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUrl(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPath(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.category.TrendKeyword.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.category.TrendKeyword.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.category.TrendKeyword} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.category.TrendKeyword.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getKeywords();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUrl();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPath();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string keywords = 1;
 * @return {string}
 */
proto.category.TrendKeyword.prototype.getKeywords = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.category.TrendKeyword} returns this
 */
proto.category.TrendKeyword.prototype.setKeywords = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string url = 2;
 * @return {string}
 */
proto.category.TrendKeyword.prototype.getUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.category.TrendKeyword} returns this
 */
proto.category.TrendKeyword.prototype.setUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string path = 3;
 * @return {string}
 */
proto.category.TrendKeyword.prototype.getPath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.category.TrendKeyword} returns this
 */
proto.category.TrendKeyword.prototype.setPath = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.category.RecentOrderService.prototype.toObject = function(opt_includeInstance) {
  return proto.category.RecentOrderService.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.category.RecentOrderService} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.category.RecentOrderService.toObject = function(includeInstance, msg) {
  var f, obj = {
    serviceId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    serviceName: jspb.Message.getFieldWithDefault(msg, 2, ""),
    userId: jspb.Message.getFieldWithDefault(msg, 3, 0),
    userName: jspb.Message.getFieldWithDefault(msg, 4, ""),
    orderDate: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.category.RecentOrderService}
 */
proto.category.RecentOrderService.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.category.RecentOrderService;
  return proto.category.RecentOrderService.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.category.RecentOrderService} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.category.RecentOrderService}
 */
proto.category.RecentOrderService.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setServiceId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setServiceName(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUserId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserName(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOrderDate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.category.RecentOrderService.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.category.RecentOrderService.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.category.RecentOrderService} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.category.RecentOrderService.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getServiceId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getServiceName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getUserId();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getUserName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getOrderDate();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
};


/**
 * optional int32 service_id = 1;
 * @return {number}
 */
proto.category.RecentOrderService.prototype.getServiceId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.category.RecentOrderService} returns this
 */
proto.category.RecentOrderService.prototype.setServiceId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string service_name = 2;
 * @return {string}
 */
proto.category.RecentOrderService.prototype.getServiceName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.category.RecentOrderService} returns this
 */
proto.category.RecentOrderService.prototype.setServiceName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 user_id = 3;
 * @return {number}
 */
proto.category.RecentOrderService.prototype.getUserId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.category.RecentOrderService} returns this
 */
proto.category.RecentOrderService.prototype.setUserId = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string user_name = 4;
 * @return {string}
 */
proto.category.RecentOrderService.prototype.getUserName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.category.RecentOrderService} returns this
 */
proto.category.RecentOrderService.prototype.setUserName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int64 order_date = 5;
 * @return {number}
 */
proto.category.RecentOrderService.prototype.getOrderDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.category.RecentOrderService} returns this
 */
proto.category.RecentOrderService.prototype.setOrderDate = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.category.Tag.prototype.toObject = function(opt_includeInstance) {
  return proto.category.Tag.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.category.Tag} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.category.Tag.toObject = function(includeInstance, msg) {
  var f, obj = {
    type: jspb.Message.getFieldWithDefault(msg, 1, ""),
    id: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.category.Tag}
 */
proto.category.Tag.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.category.Tag;
  return proto.category.Tag.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.category.Tag} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.category.Tag}
 */
proto.category.Tag.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.category.Tag.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.category.Tag.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.category.Tag} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.category.Tag.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional string type = 1;
 * @return {string}
 */
proto.category.Tag.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.category.Tag} returns this
 */
proto.category.Tag.prototype.setType = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 id = 2;
 * @return {number}
 */
proto.category.Tag.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.category.Tag} returns this
 */
proto.category.Tag.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.category.Rating.prototype.toObject = function(opt_includeInstance) {
  return proto.category.Rating.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.category.Rating} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.category.Rating.toObject = function(includeInstance, msg) {
  var f, obj = {
    overallRate: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
    comment: jspb.Message.getFieldWithDefault(msg, 2, ""),
    isAnonymity: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    createdAt: jspb.Message.getFieldWithDefault(msg, 4, 0),
    serviceId: jspb.Message.getFieldWithDefault(msg, 5, 0),
    serviceName: jspb.Message.getFieldWithDefault(msg, 6, ""),
    userName: jspb.Message.getFieldWithDefault(msg, 7, ""),
    userGender: jspb.Message.getFieldWithDefault(msg, 8, ""),
    userIconPath: jspb.Message.getFieldWithDefault(msg, 9, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.category.Rating}
 */
proto.category.Rating.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.category.Rating;
  return proto.category.Rating.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.category.Rating} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.category.Rating}
 */
proto.category.Rating.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setOverallRate(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setComment(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsAnonymity(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedAt(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setServiceId(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setServiceName(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserName(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserGender(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserIconPath(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.category.Rating.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.category.Rating.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.category.Rating} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.category.Rating.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOverallRate();
  if (f !== 0.0) {
    writer.writeFloat(
      1,
      f
    );
  }
  f = message.getComment();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getIsAnonymity();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getCreatedAt();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getServiceId();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getServiceName();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getUserName();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getUserGender();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getUserIconPath();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
};


/**
 * optional float overall_rate = 1;
 * @return {number}
 */
proto.category.Rating.prototype.getOverallRate = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.category.Rating} returns this
 */
proto.category.Rating.prototype.setOverallRate = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional string comment = 2;
 * @return {string}
 */
proto.category.Rating.prototype.getComment = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.category.Rating} returns this
 */
proto.category.Rating.prototype.setComment = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool is_anonymity = 3;
 * @return {boolean}
 */
proto.category.Rating.prototype.getIsAnonymity = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.category.Rating} returns this
 */
proto.category.Rating.prototype.setIsAnonymity = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional int64 created_at = 4;
 * @return {number}
 */
proto.category.Rating.prototype.getCreatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.category.Rating} returns this
 */
proto.category.Rating.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 service_id = 5;
 * @return {number}
 */
proto.category.Rating.prototype.getServiceId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.category.Rating} returns this
 */
proto.category.Rating.prototype.setServiceId = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string service_name = 6;
 * @return {string}
 */
proto.category.Rating.prototype.getServiceName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.category.Rating} returns this
 */
proto.category.Rating.prototype.setServiceName = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string user_name = 7;
 * @return {string}
 */
proto.category.Rating.prototype.getUserName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.category.Rating} returns this
 */
proto.category.Rating.prototype.setUserName = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string user_gender = 8;
 * @return {string}
 */
proto.category.Rating.prototype.getUserGender = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.category.Rating} returns this
 */
proto.category.Rating.prototype.setUserGender = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string user_icon_path = 9;
 * @return {string}
 */
proto.category.Rating.prototype.getUserIconPath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.category.Rating} returns this
 */
proto.category.Rating.prototype.setUserIconPath = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


goog.object.extend(exports, proto.category);
